import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import Varient from "../../assets/img/varient.png";
// import secureLocalStorage from "react-secure-storage";
import { config } from "../../utils/config";
import { doRequest, submitUserPlans } from "../../utils/helper";
import Loader from "../../components/Loader";
import "../../design/css/login.css"
import teedexlogo from "../../assets/loginimg/teedexlogo.svg"
import logoutIcon from "../../assets/loginimg/logouticn.svg"

function Verifyotp() {
  const initialUserPlanDetails = localStorage.getItem(config.USER_PLAN_DETAILS);
  const navigate = useNavigate();
  const [digit1, setDigit1] = useState('');
  const [digit2, setDigit2] = useState('');
  const [digit3, setDigit3] = useState('');
  const [digit4, setDigit4] = useState('');
  const [digit5, setDigit5] = useState('');
  const [digit6, setDigit6] = useState('');
  const [errmsg, setErrorMsg] = useState(null);
  const [loading, setLoading] = useState(false);
  const inputRefs = [
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef()
  ];

  const [params] = useSearchParams();
  const plan = params.get("plan");
  if (plan) {
    localStorage.setItem("userselectedplanid", plan);
  } else {
    if (localStorage.getItem("userselectedplanid")) {
      localStorage.removeItem("userselectedplanid");
    }
  }
  var email_id = localStorage.getItem("users_email");

  // Handle input change for individual digits
  const handleInputChange = (index, value) => {
    // Check if this is a paste event (value length > 1)
    if (value.length > 1) {
      const pastedText = value.trim();
      
      // Check if pasted text is exactly 6 digits
      if (/^\d{6}$/.test(pastedText)) {
        const digits = pastedText.split('');
        
        // Set each digit individually
        setDigit1(digits[0]);
        setDigit2(digits[1]);
        setDigit3(digits[2]);
        setDigit4(digits[3]);
        setDigit5(digits[4]);
        setDigit6(digits[5]);
        return;
      }
    }
    
    // Normal single digit input
    if (value.length <= 1) {
      // Update the specific digit state
      const setDigitFunctions = [setDigit1, setDigit2, setDigit3, setDigit4, setDigit5, setDigit6];
      setDigitFunctions[index](value);
      
      // Move to next input if value is entered
      if (value !== '' && index < 5) {
        inputRefs[index + 1].current.focus();
      }
    }
  };

  // Handle paste functionality
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData.getData('text/plain').trim();
    
    // Check if pasted text is exactly 6 digits
    if (/^\d{6}$/.test(pastedText)) {
      const digits = pastedText.split('');
      
      // Set each digit individually
      setDigit1(digits[0]);
      setDigit2(digits[1]);
      setDigit3(digits[2]);
      setDigit4(digits[3]);
      setDigit5(digits[4]);
      setDigit6(digits[5]);
    }
  };

  const resendOtp = async () => {
    setLoading(true);
    try {
      let data = {
        email: email_id,
      };
      let response = await doRequest(data, "POST", "user/resend-otp");
      if (+response?.resultFlag === 1) {
        alert("email sent");
      } else {
        setErrorMsg(
          response?.message ? response?.message : "Something went wrong!"
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMsg(error?.message ? error?.message : "Something went wrong!");
    }
  };

  const submitUserPlan = async (planid) => {
    let user =
      localStorage.getItem(config.USER_LOGIN_DETAILS) &&
      JSON.parse(localStorage.getItem(config.USER_LOGIN_DETAILS));
    try {
      let response = await submitUserPlans(planid, user);
      if (response && +response?.resultFlag === 1) {
        localStorage.removeItem("users_email");
        let details = response?.response?.user_data;
        let userPlan = response?.response?.userPlan;
        let variant = response?.response?.variants;
        if (variant) {
          localStorage.setItem(config.VARIANT_COUNT, JSON.stringify(variant));
        }
        localStorage.setItem(
          config.USER_LOGIN_DETAILS,
          JSON.stringify(details)
        );
        localStorage.setItem(
          config.USER_PLAN_DETAILS,
          JSON.stringify(userPlan)
        );

        if (initialUserPlanDetails) {
          navigate("/profile?plan=" + planid);
        } else {
          navigate("/profile?plan=" + planid + "&ftime=1");
        }
      } else {
        setErrorMsg(
          response?.message ? response?.message : "Something went wrong"
        );
      }
    } catch (error) {
      setErrorMsg(error?.message ? error?.message : "Something went wrong");
    }
  };

  var verify_otp = async (e) => {
    setLoading(true);
    e.preventDefault();

    var dataToPost = {
      email: email_id,
      otp: digit1 + digit2 + digit3 + digit4 + digit5 + digit6,
    };

    try {
      const response = await doRequest(dataToPost, "POST", "user/verify-otp");
      if (+response?.resultFlag == 1) {
        let res = response?.response;
        let token = res?.token;
        let userDetails = res?.user;
        // secureLocalStorage.setItem("Login", token);
        localStorage.setItem("Login", token);
        localStorage.setItem("token", token);
        localStorage.setItem(
          config.USER_LOGIN_DETAILS,
          JSON.stringify(userDetails)
        );
        if (plan) {
          if (plan == "1" || plan == "2") {
            await submitUserPlan(plan);
          } else {
            navigate("/payment" + window.location.search);
          }
        } else {
          navigate("/plans" + window.location.search);
        }
      } else {
        setErrorMsg(
          response?.message ? response?.message : "Something went wrong!"
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMsg(error?.message ? error?.message : "Something went wrong!");
    }
  };

  useEffect(() => {
    inputRefs[0].current.focus();
  }, []);

  return (
    <>
      {loading && <Loader />}
      {/* <div id="main-container" className="container-fluid main"> */}
        {/* <div className="sidemenu d-flex flex-column justifycontent-between min-vh-100">
          <div className="text-center mt-3">
            <ul className="nav nav-pills flex-column">
              <li>
                <img
                  src={Varient}
                  alt="Varient logo"
                  style={{ width: "50px", top: 0 }}
                />
              </li>
            </ul>
          </div>
        </div> */}

        {/* <section className="home">
          <div className="container login-container"> */}
            {/* <div className="row mt-4">
              <div className="mb-4">
                <ul className="d-flex col-11 login-tabs">
                  <li className="">Signup</li>
                  <li className="mx-2">Payment</li>
                  <li className="mx-2">Register</li>
                </ul>
              </div>
            </div> */}
            {/* <div className="row my-5">
              <div className="col-5">
                <div className="login">
                  <h3 className="text-center mb-2">Check you email</h3>
                  <p>We sent you the OTP to {email_id}</p>

                  <form onSubmit={(e) => verify_otp(e)}>
                    <p className="text-left mb-1 mt-6">Verify OTP</p>
                    <div className="otp-input-div">
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit1}
                        onChange={(e) => handleInputChange1(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit2}
                        onChange={(e) => handleInputChange2(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit3}
                        onChange={(e) => handleInputChange3(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit4}
                        onChange={(e) => handleInputChange4(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit5}
                        onChange={(e) => handleInputChange5(e)}
                      />
                      <input
                        className="otp-num-input"
                        type="text"
                        name="email"
                        maxLength="1"
                        placeholder="-"
                        ref={digit6}
                        onChange={(e) => handleInputChange4(e)}
                      />
                    </div>
                    <input
                      className="submit"
                      type="submit"
                      value="Verify OTP"
                    />
                  </form>
                  <div className="my-4 text-center">
                    <p>Didn't receive email ?</p>
                    <a onClick={() => resendOtp()} className="login-a mx-2">
                      Resend OTP
                    </a>
                    <p className="text-danger">
                      {errmsg != null ? errmsg : ""}
                    </p>
                  </div>
                  <div className="my-4 text-center">
                    <FontAwesomeIcon
                      icon={faArrowRightFromBracket}
                      rotation={180}
                      size="xs"
                      style={{ color: "#2A1FB3" }}
                    />
                    <a href="/Login" className="login-a mx-2">
                      Back to Login
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-7 d-flex justify-content-center align-items-center">
                <div className="login-title">
                  <img src={"/assets/images/logo.svg"} alt="title" />
                  <p>Join the Crafters</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> */}

 <div className="newLoginBody">
        <form className="newLoginBodyText" style={{ padding: "0 12.635vw"}} onSubmit={(e) => verify_otp(e)}>
            <div className="newLoginFormContainer newLoginFormBlock" style={{ padding: "2vw"}}>
                <h1>Check you email</h1>
                <p>We sent you the OTP to {email_id}</p>
               <div className={`otpInputs ${errmsg ? "wrongOtp" : ""}`}
                 style={{ width: "20.885vw"}}>
                    <p>{errmsg ? "Wrong OTP" : "Verify OTP"}</p>
                    <div>
                      <div className="otpInputList" style={{ flexWrap: "nowrap"}}>
                        <div className="inputContainer">
                          <input
                            className="otpInput"
                            type="text"
                            name="email"
                            maxLength="6"
                            placeholder="-"
                            ref={inputRefs[0]}
                            value={digit1}
                            onChange={(e) => handleInputChange(0, e.target.value)}
                            onInput={(e) => handleInputChange(0, e.target.value)}
                            onPaste={handlePaste}
                          />
                        </div>
                        <div className="inputContainer">
                          <input
                            className="otpInput"
                            type="text"
                            name="email"
                            maxLength="6"
                            placeholder="-"
                            ref={inputRefs[1]}
                            value={digit2}
                            onChange={(e) => handleInputChange(1, e.target.value)}
                            onInput={(e) => handleInputChange(1, e.target.value)}
                            onPaste={handlePaste}
                          />
                        </div>
                        <div className="inputContainer">
                          <input
                            className="otpInput"
                            type="text"
                            name="email"
                            maxLength="6"
                            placeholder="-"
                            ref={inputRefs[2]}
                            value={digit3}
                            onChange={(e) => handleInputChange(2, e.target.value)}
                            onInput={(e) => handleInputChange(2, e.target.value)}
                            onPaste={handlePaste}
                          />
                        </div>
                        <div className="inputContainer">
                          <input
                            className="otpInput"
                            type="text"
                            name="email"
                            maxLength="6"
                            placeholder="-"
                            ref={inputRefs[3]}
                            value={digit4}
                            onChange={(e) => handleInputChange(3, e.target.value)}
                            onInput={(e) => handleInputChange(3, e.target.value)}
                            onPaste={handlePaste}
                          />
                        </div>
                        <div className="inputContainer">
                          <input
                            className="otpInput"
                            type="text"
                            name="email"
                            maxLength="6"
                            placeholder="-"
                            ref={inputRefs[4]}
                            value={digit5}
                            onChange={(e) => handleInputChange(4, e.target.value)}
                            onInput={(e) => handleInputChange(4, e.target.value)}
                            onPaste={handlePaste}
                          />
                        </div>
                        <div className="inputContainer">
                          <input
                            className="otpInput"
                            type="text"
                            name="email"
                            maxLength="6"
                            placeholder="-"
                            ref={inputRefs[5]}
                            value={digit6}
                            onChange={(e) => handleInputChange(5, e.target.value)}
                            onInput={(e) => handleInputChange(5, e.target.value)}
                            onPaste={handlePaste}
                          />
                        </div>
                    </div>
                    </div>
                   
                </div>

                <div className="inputContainer">
                    <button type="submit" className="loginButton">Verify OTP</button>
                </div>
                <div className="didntGet">
                    Didn’t get an email? <a onClick={() => resendOtp()}>Resend</a>
                </div>
                <p className="text-danger">
                      {errmsg != null ? errmsg : ""}
                    </p>
                <div className="forgotPassword">
                    <Link to="/Login"><img src={logoutIcon} alt="" /> Back to Login</Link>
                </div>
            </div>
            <div className="formTnc newLoginFormBlock">
                By signing up for teedex you acknowledge that you agree to teedex <a href="#">Terms & Conditions</a> and <a href="#">Privacy Policy</a>
            </div>
            <div className="formTeedexLogo newLoginFormBlock">
                <img src={teedexlogo} alt="Teedex Logo" />
            </div>
            <div className="formCopyR newLoginFormBlock">© 2024 Teedex All Rights Reserved</div>
        </form>

        <div className="newLoginBodyImg"></div>
    </div>



    </>
  );
}

export default Verifyotp;
